export const mutations = {
    SET_LAYOUT (state, payload) {
        state.currentLayout = payload
    },

    SET_PATIENT (state, payload) {
        state.patient = payload
    },

    SET_PATIENT_POSITION (state, payload) {
        state.patientPosition = payload
    },

    SET_PATIENT_PLACE (state, payload) {
        state.patientPlace = payload
    },

    SET_PATIENT_PLACE_NAME (state, payload) {
        state.patientPlaceName = payload
    },

    SET_PATIENT_MEDICAL_PRACTICE (state, payload) {
        state.patientMedicalPractice = payload
    },

    SET_FRONT_LANGUAGE (state, payload) {
        state.frontLanguage = payload
    },

    SET_ONLINE (state, payload) {
        state.online = payload
    },

    setPreventBodyScroll(state, payload) {
        state.preventBodyScroll  = payload
    },

    setLoading(state, payload) {
        state.loading  = payload
    },

    setOnboardingStep(state, payload) {
        state.onboardingStep  = payload
    },

    setLoaded(state, payload) {
        state.loaded  = payload
    },

    setCurrentOffice(state, payload) {
        state.currentOffice = payload
    },

    setCurrentDate(state, payload) {
        state.currentDate = payload
    },

    listenAppointments(state, payload) {
        state.listenAppointments = payload
    },

    setFirebaseToken(state, payload) {
        state.firebaseToken = payload
    },

    setUserId(state, payload) {
        state.userId = payload
    },

    addNotification(state, payload) {
        state.notifications.push(payload)
    },

    disableNotification(state, payload) {
        payload.active = false
    },

    setDoctor(state, payload) {
        state.doctor = payload
    },

    setOffices(state, payload) {
        state.offices = payload
        if (! state.currentOffice && Object.keys(payload).length) {
            for (let i in state.offices) {
                state.currentOffice = i

                break
            }
        }
    },

    setOffice(state, payload) {
        state.offices[payload.id] = payload
    },

    setRecommendations(state, payload) {
        state.recommendations = payload
    },

    removeOffice(state, payload) {
        // Update Current Office if we deleted this one
        if (state.currentOffice == payload) {
            if (Object.keys(state.offices).length) {
                for (var i in state.offices) {
                    state.currentOffice = i

                    break;
                }
            } else {
                state.currentOffice = null
            }
        }

        delete state.offices[payload]
    },

    setLanguages(state, payload) {
        state.languages = payload
    },

    setCountries(state, payload) {
        state.countries = payload
    },

    setDefaultCountryId(state, payload) {
        state.defaultCountryId = payload
    },

    setFormError(state, payload) {
        state.formError = payload
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js